/* drag-column-preview.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import "./drag-column-preview.compiled.css";
import { forwardRef } from 'react';
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @atlaskit/design-system/use-tokens-typography */

import React from 'react';
import { N40 } from '@atlaskit/theme/colors';
import { fontFallback } from '@atlaskit/theme/typography';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
var TableHeading = forwardRef(function (_ref, __cmplr) {
  var _ref$as = _ref.as,
    C = _ref$as === void 0 ? "th" : _ref$as,
    __cmpls = _ref.style,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19itidpf _aks5idpf _1u3bidpf _1s7zl0fh _1o9ml0fh _1oupl0fh _n7zl1md5 _1fqk1md5 _1vvv1md5 _kqswh2mm _rc4eh2mm _q46wh2mm _vchhusvi _1wwnusvi _1gbausvi _vwz41tcg _s99e1tcg _3mvc1tcg _ca0qv77o _7cz2v77o _pcwyv77o _u5f31b66 _1pmc1b66 _11ep1b66 _n3tdv77o _6dd7v77o _191qv77o _19bv1b66 _9iya1b66 _15hu1b66 _4t3iqagn _qccgqagn _xo89qagn _s7n4yfq0 _ntwryfq0 _3eneyfq0 _bfhkchd4 _i7olchd4 _1oe6chd4 _12pn15vq _198v15vq _lura1osq _11681tcg _ab8av77o _11j11b66 _1xanv77o _8lvj1b66 _iscccj1k _1nd0cs5v _1t0u1e54 _1eqz4jg8 _95ex1hna _1hkzidpf _1r3pidpf _10i2idpf _1ls2idpf _ocbzidpf _3tfiidpf _1lhc1b66 _n2z81b66 _3ixo1b66", __cmplp.className])
  }));
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
if (process.env.NODE_ENV !== 'production') {
  TableHeading.displayName = 'TableHeading';
}
var TablePreviewHeading = forwardRef(function (_ref2, __cmplr) {
  var _ref2$as = _ref2.as,
    C = _ref2$as === void 0 ? TableHeading : _ref2$as,
    __cmpls = _ref2.style,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1reo15vq _18m915vq _1bto1l2s _o5721q9c _bfhk98cj _p12fuuw1 _1lhcu2gc _u128u2gc _1djhu2gc _1o59u2gc", __cmplp.className])
  }));
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
if (process.env.NODE_ENV !== 'production') {
  TablePreviewHeading.displayName = 'TablePreviewHeading';
}
var TablePreviewCell = forwardRef(function (_ref3, __cmplr) {
  var _ref3$as = _ref3.as,
    C = _ref3$as === void 0 ? "td" : _ref3$as,
    __cmpls = _ref3.style,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1reo15vq _18m915vq _n7zll0fh _1bto1l2s _o5721q9c _p12fuuw1 _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _vchhusvi _4t3i1ul9 _1lhcu2gc _u128u2gc _1djhu2gc _1o59u2gc", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  TablePreviewCell.displayName = 'TablePreviewCell';
}
var tableStyles = null;
export var DragColumnPreview = function DragColumnPreview(_ref4) {
  var title = _ref4.title,
    rows = _ref4.rows;
  return /*#__PURE__*/React.createElement("table", {
    className: ax(["_bfhkvuon _yq5hus1c _btyzidpf _p12fuuw1 _zzcc4f4w _x3fxnil1 _u6rdk9i7 _v2glf7ua"])
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TablePreviewHeading, null, title))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (data, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement(TablePreviewCell, null, data));
  }), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TablePreviewCell, null, "..."))));
};